import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/health')({
  component: () => <pre style={{ margin: 16 }}>OK</pre>,
})
